import { CustomizationMeshImageData, ICustomizationMeshImageData } from './CustomizationMeshImageData';

export interface ICustomizationMeshImage {
  customizationID : number;
  customizationData : ICustomizationMeshImageData;
}

export class CustomizationMeshImage implements ICustomizationMeshImage {
  customizationID: number = 0;
  customizationData: ICustomizationMeshImageData = new
  CustomizationMeshImageData();
}
